module.exports = __webpack_public_path__ + "img/hero-sass-bg.180087ae.jpg";